import React from 'react';
import { ReactComponent as AudioBars } from '../../../assets/svg/AudioBars.svg';
import { ReactComponent as AudioPlayIcon } from '../../../assets/svg/AudioPlayIcon.svg';
import { ReactComponent as PauseIcon } from '../../../assets/svg/PauseIcon.svg';

function Audio({ solution, handleClickAudioControl, soundPlayable }: { solution: any; handleClickAudioControl: any; soundPlayable: any }) {
	return (
		<div className='bg-white w-full h-[159px] rounded-t-[25px] p-5 absolute bottom-0 flex flex-col justify-between -ml-5'>
			<p className='font-bold text-primaryViolet text-[20px] leading-[26px] '>{solution?.audioTitle}</p>
			<div className='bg-[#ECEDF5] py-[10px] px-[15px] rounded-[15px] flex flex-row gap-5'>
				<div className='flex-1 flex flex-col justify-center gap-[10px] '>
					<div className='flex flex-row items-center gap-[5px] '>
						<div className='w-[7px] h-[7px] rounded-full bg-[#FFBF5C] '></div>
						<p className='font-bold text-[#02393E] text-[16px] leading-[20px] '>{solution?.audio?.duration ?? 33} sec</p>
					</div>
					<AudioBars />
				</div>
				<div className='w-[60px] h-[60px] bg-[#FFBF5C] rounded-full flex items-center justify-center cursor-pointer' onClick={() => handleClickAudioControl()}>
					{soundPlayable ? <AudioPlayIcon style={{ marginLeft: 2 }} /> : <PauseIcon style={{ marginLeft: 2 }} />}
				</div>
			</div>
		</div>
	);
}

export default Audio;
